<template>
  <div class="c-meta-box">
    <div class="c-meta-box__inner">
      <header class="c-meta-box__header"></header>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'meta-box',
};
</script>


<style lang="scss">
.c-meta-box {
  position: relative;

  &__inner {
    border-radius: 0px 0px 4px 4px;
    overflow: hidden;
    border-top: 6px solid $colour-nhs-blue;
    width: 100%;
    background: $colour-nhs-white;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  }
}
</style>
